
import Designtools from "../../../assets/duotone/Designtools.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DesigntoolsIcon({ className, dataTestid = "DesigntoolsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Designtools data-testid={dataTestid} className={classes} {...rest} />
  );
}
